import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { start: String }

  connect() {
    this.update()
    this.timer = setInterval(() => this.update(), 1000)
  }

  disconnect() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }

  update() {
    const start = new Date(this.startValue)
    const now = new Date()
    const diff = Math.floor((now - start) / 1000)

    if (diff < 0) {
      this.element.textContent = "00:00:00"
      return
    }

    const hours = Math.floor(diff / 3600)
    const minutes = Math.floor((diff % 3600) / 60)
    const seconds = diff % 60

    this.element.textContent =
      String(hours).padStart(2, "0") + ":" +
      String(minutes).padStart(2, "0") + ":" +
      String(seconds).padStart(2, "0")
  }
}
